import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ExpandedTable } from "@ryde/controls";
import { getBookingCalendarCellId } from "@ryde/shared";

import { BulkPreviewStepConflictsContext } from "../bulk-preview-step-conflicts.context";
import { RejectedBookingExpanded } from "./rejected-bookings-expanded";
import { RejectedBookingsPassengerIneligibleRow } from "./rejected-bookings-passenger-ineligible-row";

export const RejectedBookingsPassengerIneligibleTable: FC = () => {
  const { conflicts, isPreview } = useContext(BulkPreviewStepConflictsContext);
  const { t } = useTranslation();

  return (
    <RejectedBookingExpanded>
      <ExpandedTable dataE2E="rejected-bookings-passenger-ineligible">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t("booking.bulk.passengerFullName")}</TableCell>
              <TableCell>{t("booking.bulk.ineligibleErrorType")}</TableCell>
              <TableCell>{t("booking.bulk.approvalReason")}</TableCell>
              <TableCell>{t("booking.bulk.date")}</TableCell>
              {isPreview && <TableCell />}
            </TableRow>
          </TableHead>
          <TableBody>
            {conflicts?.map(conflictRow => (
              <RejectedBookingsPassengerIneligibleRow
                key={`${getBookingCalendarCellId(conflictRow.passengerId as number, conflictRow.date)}_${conflictRow.id}`}
                conflictRow={conflictRow}
              />
            ))}
          </TableBody>
        </Table>
      </ExpandedTable>
    </RejectedBookingExpanded>
  );
};
